import Box from "@mui/material/Box";
import dynamic from "next/dynamic";
import Image from "next/image";
import Grid from "@mui/material/Grid";
import { colors } from "../../utils/const";
import { useI18n } from "@/i18n/I18nProvider";
import EmailIcon from "@mui/icons-material/Email";
import LocalPhoneIcon from "@mui/icons-material/LocalPhone";
// import CustomHeading from "@/components/custom-heading";

// Better: SSR on for SEO + faster first interaction
const PageHead = dynamic(() => import("@/components/PageHead"), { ssr: true });
const Form = dynamic(() => import("../../components/contact-us/Form.jsx"), {
  ssr: true,
});
const Title = dynamic(() => import("../../components/contact-us/Title.jsx"), {
  ssr: true,
});

export default function Index() {
  const { t, locale } = useI18n();


  return (
    <>
      <PageHead
        title={t.pages_main_tags.contactUs.title}
        description={t.pages_main_tags.contactUs.meta_desc}
      />

      <Box
        className="horizontal-safe-margin vertical-safe-margin"
        sx={{
          display: "flex",
          flexWrap: "wrap",
          justifyContent: { xs: "center", xl: "space-between" },
          // gap: 5,
          alignItems: { lg: "flex-start" },
        }}
      >
        <Grid container alignItems="center" spacing={{ sm: 4, md: 6 }}>
           <Grid item xs={12} md={6}>
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  pb: 5,
                }}
              >
                <Title h1="h1" title={t.contact_us_title} />

                <Box sx={{ my: 2, mx: { xs: "auto", md: 0 }, display: "flex", alignItems: "center" }}>
                  <EmailIcon sx={{ color: colors.orange }} />
                  <Box
                    component="a"
                    sx={{ mx: 2, textDecoration: "none", color: colors.blue }}
                    href="mailto:Info@contact.eg"
                  >
                    Info@contact.eg
                  </Box>
                </Box>

                <Box sx={{ mb: 2, mx: { xs: "auto", md: 0 }, display: "flex", alignItems: "center" }}>
                  <LocalPhoneIcon sx={{ color: colors.orange }} />
                  <Box
                    component="a"
                    sx={{ mx: 2, textDecoration: "none", color: colors.blue }}
                    href="tel:16177"
                    aria-label="Call us at 16177"
                  >
                    16177
                  </Box>
                </Box>

                {/* LCP Image - use next/image to reduce CLS + optimize loading */}
                <Box
                  sx={{
                    width: { xs: 200, sm: 300, md: 400, lg: 460 },
                    height: { xs: 200, sm: 300, md: 400, lg: 460 },
                    mt: { xs: 3, md: "auto" },
                    mx: "auto",
                    borderRadius: "12px",
                    overflow: "hidden",
                    position: "relative",
                  }}
                >
                  <Image
                    src="https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/contact-us-cover.webp"
                    alt="contact us cover"
                    fill
                    priority
                    fetchPriority="high"
                    sizes="(max-width: 600px) 200px, (max-width: 900px) 300px, (max-width: 1200px) 400px, 460px"
                    style={{ objectFit: "cover" }}
                  />
                </Box>
              </Box>
            </Grid>
          <Grid item xs={12} md={6}>
             <Form color={colors.blue} />
          </Grid>
        </Grid>
      </Box>
    </>
  );
}
